import React, {useState} from 'react';
import { Grid, Card, CardContent, CardMedia, Typography, Button } from '@mui/material';
import { base_url } from '../../utils/baseUrl';
import TextTruncate from 'react-text-truncate';
import fallBackImg from '../../assets/card-alt-img.png'

const ItemCard = ({data}) => {
  const [expanded, setExpanded] = useState(false);
 
  const handleRedirect=()=>{
    const url = data?.urlPath;
    window.open(url, '_blank');
  }
  const getImgUrl = (imgUrl) =>{
    var imageUrl = fallBackImg
    if(imgUrl){
      imageUrl=imgUrl.image
    }
    if(imageUrl.indexOf("http") == -1){
      imageUrl = fallBackImg
    }
    return imageUrl
  }

  return (
    <>
    <Grid item key={data.id} xs={12} sm={6} md={4}>
    {data &&  <Card style={{ backgroundColor: 'white', color: 'black', height: '420px', marginLeft: '-27px', border: '0.1px solid grey'}}>
    <div className="card" onClick={handleRedirect}>
      <CardMedia 
        component="img"
        image={getImgUrl(data)}
        alt={data.title}
        style={{height: '140px', width: '42%', objectFit:'initial', marginLeft:'18px', marginTop: '18px', borderRadius:'5px'}}/>
    </div>
      <CardContent style={{marginTop:'25px'}}>
        <Typography onClick={handleRedirect} gutterBottom variant="h5" component="div">
        <TextTruncate className="title"line={1}
                      truncateText="…"
                      text={data.title}
        />
        </Typography>
          <div className="card">
              {expanded ? (
                  <Typography style={{fontSize: '16px', color:'black'}} variant="body2" className="desc" color="text.secondary">
                  {data.description}
                  <a
                    style={{ color: 'black', marginLeft:'5px' }}
                    onClick={() => {
                      setExpanded(!expanded);
                    }}>
                    Read Less
                  </a>
                  </Typography>
                  ) : (
                  <TextTruncate
                    style={{color:'black'}}
                    line={4}
                    truncateText="…"
                    text={data.description}
                    textTruncateChild={<a style={{ color: 'black', marginLeft:'5px'}} onClick={() => {setExpanded(!expanded)}}>Read More</a>}
                  />
                  )} 
            </div> 
        <div className="btn">
        {/* <Button style={{ backgroundColor: '#161313', color: 'white' ,height:'40px', margin: '40px'}} onClick={handleRedirect}>
          Launch Prototype
        </Button> */}
        </div>
      </CardContent>
    </Card>}
   
  </Grid>
  </>
  )
}


export default ItemCard;



